import { TypographyVariantsOptions } from '@mui/material';
import scssVariables from '@styles/variables.module.scss';

const bodyRegular = {
  fontSize: scssVariables.FontSizeBodyRegular,
  fontWeight: scssVariables.FontWeightBodyRegular,
  lineHeight: scssVariables.LineHeightBodyRegular,
};
const bodyLight = {
  fontSize: scssVariables.FontSizeBodyLight,
  fontWeight: scssVariables.FontWeightBodyLight,
  lineHeight: scssVariables.LineHeightBodyLight,
};
const bodySemiBold = {
  fontSize: scssVariables.FontSizeBodySemiBold,
  fontWeight: scssVariables.FontWeightBodySemiBold,
  lineHeight: scssVariables.LineHeightBodySemiBold,
};
const bodyBold = {
  fontSize: scssVariables.FontSizeBodyBold,
  fontWeight: scssVariables.FontWeightBodyBold,
  lineHeight: scssVariables.LineHeightBodyBold,
};

const label = {
  fontSize: scssVariables.FontSizeLabel,
  fontWeight: scssVariables.FontWeightLabel,
  lineHeight: scssVariables.LineHeightLabel,
};
const h1 = {
  fontSize: scssVariables.FontSizeH1,
  fontWeight: scssVariables.FontWeightH1,
  lineHeight: scssVariables.LineHeightH1,
};
const h2 = {
  fontSize: scssVariables.FontSizeH2,
  fontWeight: scssVariables.FontWeightH2,
  lineHeight: scssVariables.LineHeightH2,
};
const h3 = {
  fontSize: scssVariables.FontSizeH3,
  fontWeight: scssVariables.FontWeightH3,
  lineHeight: scssVariables.LineHeightH3,
};
const h3SemiBold = {
  fontSize: scssVariables.FontSizeH3,
  fontWeight: scssVariables.FontWeightH3SemiBold,
  lineHeight: scssVariables.LineHeightH3,
};
const h4 = {
  fontSize: scssVariables.FontSizeH4,
  fontWeight: scssVariables.FontWeightH4,
  lineHeight: scssVariables.LineHeightH4,
};
const display1 = {
  fontSize: scssVariables.FontSizeDisplay1,
  fontWeight: scssVariables.FontWeightDisplay1,
  lineHeight: scssVariables.LineHeightDisplay1,
};
const display2 = {
  fontSize: scssVariables.FontSizeDisplay2,
  fontWeight: scssVariables.FontWeightDisplay2,
  lineHeight: scssVariables.LineHeightDisplay2,
};
const display3 = {
  fontSize: scssVariables.FontSizeDisplay3,
  fontWeight: scssVariables.FontWeightDisplay3,
  lineHeight: scssVariables.LineHeightDisplay3,
};

export const typography: TypographyVariantsOptions = {
  fontFamily: scssVariables.FontFamily,
  fontSize: 14,
  body1: bodyRegular,
  bodyRegular: bodyRegular,
  bodyLight: bodyLight,
  bodyBold: bodyBold,
  bodySemiBold: bodySemiBold,
  label: label,
  h1: h1,
  h2: h2,
  h3: h3,
  h3SemiBold: h3SemiBold,
  h4: h4,
  display1: display1,
  display2: display2,
  display3: display3,

  bodyRegularMono: {
    ...bodyRegular,
    fontFamily: scssVariables.FontFamilyMono,
  },
  bodyLightMono: {
    ...bodyLight,
    fontFamily: scssVariables.FontFamilyMono,
  },
  bodyBoldMono: {
    ...bodyBold,
    fontFamily: scssVariables.FontFamilyMono,
  },
  bodySemiBoldMono: {
    ...bodySemiBold,
    fontFamily: scssVariables.FontFamilyMono,
  },
  labelMono: {
    ...label,
    fontFamily: scssVariables.FontFamilyMono,
  },
  h1Mono: {
    ...h1,
    fontFamily: scssVariables.FontFamilyMono,
  },
  h2Mono: {
    ...h2,
    fontFamily: scssVariables.FontFamilyMono,
  },
  h3Mono: {
    ...h3,
    fontFamily: scssVariables.FontFamilyMono,
  },
  h4Mono: {
    ...h4,
    fontFamily: scssVariables.FontFamilyMono,
  },
  display1Mono: {
    ...display1,
    fontFamily: scssVariables.FontFamilyMono,
  },
  display2Mono: {
    ...display2,
    fontFamily: scssVariables.FontFamilyMono,
  },
  display3Mono: {
    ...display3,
    fontFamily: scssVariables.FontFamilyMono,
  },
};
